var _circle, _circle2, _circle3, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRegister(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30.36,
    cy: 39.68,
    r: 15.54,
    fill: "#0dd6ae"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.43,
    cy: 23.61,
    r: 7.29,
    fill: "#0dd6ae"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 47.82,
    cy: 13.43,
    r: 8.25,
    fill: "#12bd87"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#005560",
    d: "M32 60.61a26.56 26.56 0 1 1 8.36-51.77 1.49 1.49 0 0 1 .88.79 1.45 1.45 0 0 1 0 1.19 7.26 7.26 0 0 0-.5 2.66 7.08 7.08 0 0 0 11.32 5.68 1.51 1.51 0 0 1 2.15.38A26.56 26.56 0 0 1 32 60.61Zm0-50.11a23.55 23.55 0 0 0-14.55 42.07 23.86 23.86 0 0 0 3.55 2.3 23.49 23.49 0 0 0 22 0 23.86 23.86 0 0 0 3.54-2.3 23.54 23.54 0 0 0 6-30.13 10.09 10.09 0 0 1-14.73-9 10.18 10.18 0 0 1 .19-2.17 23.75 23.75 0 0 0-6-.77Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#005560",
    d: "M32 41.66a6.95 6.95 0 1 1 7-6.95 7 7 0 0 1-7 6.95zm0-10.9a3.95 3.95 0 1 0 4 3.95 4 4 0 0 0-4-3.95zm0 29.85a26.51 26.51 0 0 1-12.42-3.09 1.52 1.52 0 0 1-.8-1.34 13.22 13.22 0 0 1 26.44 0 1.52 1.52 0 0 1-.8 1.34A26.51 26.51 0 0 1 32 60.61zM21.83 55.3a23.89 23.89 0 0 0 20.34 0 10.22 10.22 0 0 0-20.34 0zm26.02-31.73a10.09 10.09 0 1 1 6-2 10 10 0 0 1-6 2zm0-17.18a7.08 7.08 0 0 0-6.58 4.44 7.17 7.17 0 0 0-.5 2.65 7.09 7.09 0 1 0 7.08-7.09z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#005560",
    d: "M48 17.4a1.5 1.5 0 0 1-1.5-1.5v-4.48a1.5 1.5 0 0 1 3 0v4.48a1.5 1.5 0 0 1-1.5 1.5Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#005560",
    d: "M50.21 15.16h-4.48a1.5 1.5 0 0 1 0-3h4.48a1.5 1.5 0 0 1 0 3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegister);
export default __webpack_public_path__ + "static/media/register.4d95b875abf4b888c1ad550aec3bd1f9.svg";
export { ForwardRef as ReactComponent };